import React from "react";
import AboutImage from "../assets/image1.jpeg";
import {
  FileText,
  Package,
  Users,
  BarChart3,
  CheckCircle2,
} from "lucide-react";

import "../public css/About.css";

const About = () => {
  return (
    <div className="billing-about">

      {/* ================= HERO ================= */}

      <section className="about-hero">

        <div className="about-container about-hero-grid">

          {/* LEFT CONTENT */}

          <div className="about-hero-content">

            <span className="about-label">
              ABOUT DECTWIN
            </span>

            <h1>
              Simple billing for
              <span> growing businesses.</span>
            </h1>

            <p>
              Dectwin is a simple and reliable billing platform
              designed to help businesses manage invoices,
              inventory, customers and daily operations easily.
            </p>

          </div>


          {/* RIGHT IMAGE */}

          <div className="about-hero-image">

            <div className="about-image-card">

              <img
                src={AboutImage}
                alt="Business Management"
              />

            </div>

          </div>

        </div>

      </section>


      {/* ================= ABOUT PLATFORM ================= */}

      <section className="about-content">

        <div className="about-container about-grid">

          {/* LEFT */}

          <div className="about-text">

            <span className="about-label">
              OUR PLATFORM
            </span>

            <h2>
              Everything you need
              to manage your business.
            </h2>

            <p>
              Managing a business should not be complicated.
              Dectwin brings essential billing and business
              management tools together in one easy-to-use
              platform.
            </p>

            <p>
              From creating professional invoices to tracking
              inventory and maintaining customer records,
              Dectwin helps you keep your business organized
              and efficient.
            </p>

            <div className="about-check-list">

              <div>
                <CheckCircle2 size={18} />
                <span>Easy invoice management</span>
              </div>

              <div>
                <CheckCircle2 size={18} />
                <span>Simple inventory tracking</span>
              </div>

              <div>
                <CheckCircle2 size={18} />
                <span>Organized customer records</span>
              </div>

              <div>
                <CheckCircle2 size={18} />
                <span>Clear business insights</span>
              </div>

            </div>

          </div>


          {/* RIGHT CARDS */}

          <div className="about-features">

            <div className="about-card">

              <div className="about-icon">
                <FileText size={22} />
              </div>

              <h3>
                Invoicing
              </h3>

              <p>
                Create and manage professional invoices
                quickly and easily.
              </p>

            </div>


            <div className="about-card">

              <div className="about-icon">
                <Package size={22} />
              </div>

              <h3>
                Inventory
              </h3>

              <p>
                Keep track of your products and stock
                in one organized place.
              </p>

            </div>


            <div className="about-card">

              <div className="about-icon">
                <Users size={22} />
              </div>

              <h3>
                Customers
              </h3>

              <p>
                Manage customer details and billing
                history with ease.
              </p>

            </div>


            <div className="about-card">

              <div className="about-icon">
                <BarChart3 size={22} />
              </div>

              <h3>
                Business Insights
              </h3>

              <p>
                Understand your business with useful
                sales and billing information.
              </p>

            </div>

          </div>

        </div>

      </section>


      {/* ================= SIMPLE CTA ================= */}

      <section className="about-bottom">

        <div className="about-container">

          <h2>
            Built to make billing simple.
          </h2>

          <p>
            Spend less time managing paperwork and more
            time focusing on your business.
          </p>

        </div>

      </section>

    </div>
  );
};

export default About;